import { render } from "./MerchantOrderDetailOriginal.vue?vue&type=template&id=1c6e3ec5&scoped=true"
import script from "./MerchantOrderDetailOriginal.vue?vue&type=script&lang=js"
export * from "./MerchantOrderDetailOriginal.vue?vue&type=script&lang=js"

import "./MerchantOrderDetailOriginal.vue?vue&type=style&index=0&id=1c6e3ec5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6e3ec5"]])

export default __exports__